const molecules = [[{
    'type' : 'polygon',
    'properties' : {
        'fill' : '#31B5AD',
        'points' : '74,41.2 59.3,32.3 44.5,41.2 44.5,59 59.3,68 74,59 '
    }
}, {
    'type' : 'polygon',
    'properties' : {
        'fill' : '#008295',
        'points' : '88.7,32.3 74,41.2 59.3,32.3 59.3,14.4 74,5.5 88.7,14.4 '
    }
}, {
    'type' : 'polygon',
    'properties' : {
        'fill' : '#008295',
        'points' : '59.3,14.3 44.4,5.3 29.5,14.3 29.5,32.3 44.4,41.3 59.3,32.3 '
    }
}, {
    'type' : 'g',
    'properties' : {
        'opacity' : '0.8'
    }
}, {
    'type' : 'polygon',
    'properties' : {
        'fill' : '#FBFAFF',
        'points' : '74,23.2 59.3,14.3 44.5,23.2 44.5,41 59.3,49.9 74,41 '
    }
}, {
    'type' : 'path',
    'properties' : {
        'fill' : '#073867',
        'd' : 'M87.9,72c-0.8,0.6-1.8,0.9-3.2,0.9H82v4.7h-2.7v-13h5.6c1.3,0,2.3,0.3,3.1,1s1.1,1.7,1.1,3.1C89.1,70.3,88.7,71.4,87.9,72z M85.9,67.3c-0.3-0.3-0.8-0.4-1.4-0.4H82v3.8h2.4c0.6,0,1.1-0.2,1.4-0.5c0.3-0.3,0.5-0.8,0.5-1.5S86.2,67.6,85.9,67.3z'
    }
}, {
    'type' : 'path',
    'properties' : {
        'fill' : '#073867',
        'd' : 'M99.7,64.6h3.9v13H101v-8.8c0-0.3,0-0.6,0-1.1s0-0.8,0-1.1l-2.5,10.9H96l-2.4-10.9c0,0.2,0,0.6,0,1.1s0,0.8,0,1.1v8.8H91v-13H95l2.4,10.2L99.7,64.6z'
    }
}], [{
    'type' : 'polygon',
    'properties' : {
        'fill' : '#EEDA23',
        'points' : '86.7,50.2 58.8,65.6 31.2,50.3 31.2,19.7 58.8,4.5 86.8,19.7 '
    }
}, {
    'type' : 'polygon',
    'properties' : {
        'fill' : '#FFF200',
        'points' : '73.3,27.3 73.2,43.7 58.9,51.8 44.8,43.5 44.9,27.2 59.2,19 '
    }
}, {
    'type' : 'g',
    'properties' : {
        'opacity' : '0.9',
        'enable-background' : 'new '
    }
}, {
    'type' : 'polygon',
    'properties' : {
        'fill' : '#FBFAFF',
        'points' : '73,27.3 58.8,35.4 44.6,27.2 59.1,19 '
    }
}, {
    'type' : 'path',
    'properties' : {
        'fill' : '#073867',
        'd' : 'M81.2,73.6c0.1,0.6,0.2,1,0.5,1.3c0.4,0.5,1.2,0.8,2.3,0.8c0.7,0,1.2-0.1,1.6-0.2c0.8-0.3,1.2-0.8,1.2-1.5c0-0.4-0.2-0.8-0.6-1c-0.4-0.2-1-0.4-1.8-0.6l-1.4-0.3c-1.4-0.3-2.3-0.6-2.8-1c-0.9-0.6-1.3-1.5-1.3-2.8c0-1.2,0.4-2.1,1.3-2.9c0.9-0.8,2.1-1.2,3.8-1.2c1.4,0,2.6,0.4,3.5,1.1c1,0.7,1.5,1.8,1.5,3.2h-2.6c0-0.8-0.4-1.3-1-1.7c-0.4-0.2-1-0.3-1.6-0.3c-0.7,0-1.3,0.1-1.7,0.4c-0.4,0.3-0.6,0.7-0.6,1.2c0,0.5,0.2,0.8,0.6,1c0.3,0.2,0.8,0.3,1.7,0.5l2.3,0.5c1,0.2,1.7,0.5,2.2,0.9c0.8,0.6,1.2,1.5,1.2,2.6c0,1.2-0.5,2.2-1.4,2.9c-0.9,0.8-2.2,1.2-3.9,1.2c-1.7,0-3-0.4-4-1.2c-1-0.8-1.5-1.8-1.5-3.2H81.2z'
    }
}, {
    'type' : 'path',
    'properties' : {
        'fill' : '#073867',
        'd' : 'M101,76.4c-1,1-2.4,1.5-4.2,1.5s-3.3-0.5-4.2-1.5c-1.3-1.2-2-3-2-5.3c0-2.4,0.7-4.2,2-5.3c1-1,2.4-1.5,4.2-1.5s3.3,0.5,4.2,1.5c1.3,1.2,2,3,2,5.3C103,73.4,102.3,75.2,101,76.4z M99.3,74.5c0.6-0.8,0.9-1.9,0.9-3.4c0-1.5-0.3-2.6-0.9-3.4c-0.6-0.8-1.5-1.2-2.6-1.2s-1.9,0.4-2.6,1.2s-1,1.9-1,3.4s0.3,2.6,1,3.4s1.5,1.2,2.6,1.2S98.7,75.3,99.3,74.5z'
    }
}, {
    'type' : 'path',
    'properties' : {
        'fill' : '#073867',
        'd' : 'M104.2,82.1c0.2-0.5,0.7-1,1.5-1.6c0.7-0.5,1.1-0.8,1.3-1c0.3-0.3,0.5-0.7,0.5-1.1c0-0.3-0.1-0.6-0.3-0.8c-0.2-0.2-0.4-0.3-0.7-0.3c-0.4,0-0.7,0.2-0.9,0.5c-0.1,0.2-0.1,0.5-0.2,0.9h-1.4c0-0.6,0.1-1.1,0.3-1.5c0.4-0.7,1.1-1.1,2.1-1.1c0.8,0,1.4,0.2,1.9,0.7c0.5,0.4,0.7,1,0.7,1.7c0,0.5-0.2,1-0.5,1.5c-0.2,0.3-0.6,0.6-1.1,0.9l-0.6,0.4c-0.4,0.3-0.6,0.4-0.8,0.6c-0.1,0.1-0.2,0.3-0.3,0.4h3.2v1.3h-5.1C103.8,83.1,104,82.6,104.2,82.1z'
    }
}], [{
    'type' : 'polygon',
    'properties' : {
        'fill' : '#BA9BC8',
        'points' : '86.6,50.6 58.9,65.9 31.3,50.6 31.3,19.9 58.9,4.5 86.6,19.9 '
    }
}, {
    'type' : 'polygon',
    'properties' : {
        'fill' : '#FBFAFF',
        'points' : '57.1,48 47.3,53.5 37.6,48 37.6,37.2 47.3,31.8 57.1,37.2 '
    }
}, {
    'type' : 'polygon',
    'properties' : {
        'fill' : '#FBFAFF',
        'points' : '68.8,28 59,33.5 49.3,28 49.3,17.2 59,11.8 68.8,17.2 '
    }
}, {
    'type' : 'polygon',
    'properties' : {
        'fill' : '#FBFAFF',
        'points' : '80.7,48.2 71,53.6 61.2,48.2 61.2,37.4 71,32 80.7,37.4 '
    }
}, {
    'type' : 'path',
    'properties' : {
        'fill' : '#073867',
        'd' : 'M106.6,83.6h-1.9l2.5-4l-2.4-3.9h2l1.4,2.6l1.5-2.6h1.9l-2.4,3.8l2.6,4.1h-2l-1.5-2.7L106.6,83.6z'
    }
}, {
    'type' : 'path',
    'properties' : {
        'fill' : '#073867',
        'd' : 'M79.2,64.6H82l5.1,9v-9h2.5v13H87l-5.3-9.2v9.2h-2.5V64.6z'
    }
}, {
    'type' : 'path',
    'properties' : {
        'fill' : '#073867',
        'd' : 'M102,76.4c-1,1-2.4,1.5-4.2,1.5c-1.9,0-3.3-0.5-4.2-1.5c-1.3-1.2-2-3-2-5.3c0-2.4,0.7-4.2,2-5.3c1-1,2.4-1.5,4.2-1.5c1.9,0,3.3,0.5,4.2,1.5c1.3,1.2,2,3,2,5.3C104,73.4,103.3,75.2,102,76.4z M100.3,74.5c0.6-0.8,0.9-1.9,0.9-3.4c0-1.5-0.3-2.6-0.9-3.4c-0.6-0.8-1.5-1.2-2.6-1.2s-1.9,0.4-2.6,1.2s-1,1.9-1,3.4s0.3,2.6,1,3.4s1.5,1.2,2.6,1.2S99.7,75.3,100.3,74.5z'
    }
}], [{
    'type' : 'polygon',
    'properties' : {
        'fill' : '#FF7164',
        'points' : '87.2,50.9 59.1,66.6 31.1,51.1 31.1,20 59.1,4.4 87.2,20 '
    }
}, {
    'type' : 'polygon',
    'properties' : {
        'fill' : '#FE9F98',
        'points' : '79.7,46.7 59.2,58 38.9,46.8 38.9,24.2 59.2,13 79.5,24.2 '
    }
}, {
    'type' : 'polygon',
    'properties' : {
        'fill' : '#FCCCCB',
        'points' : '71.7,42.4 59,49.4 46.4,42.5 46.4,28.5 59,21.6 71.6,28.5 '
    }
}, {
    'type' : 'polygon',
    'properties' : {
        'fill' : '#FBFAFF',
        'points' : '63.8,38.2 59,40.8 54.2,38.2 54.2,32.8 59,30.2 63.8,32.8 '
    }
}, {
    'type' : 'path',
    'properties' : {
        'fill' : '#073867',
        'd' : 'M79.2,64.6H82l5.1,9v-9h2.5v13H87l-5.3-9.2v9.2h-2.5V64.6z'
    }
}, {
    'type' : 'path',
    'properties' : {
        'fill' : '#073867',
        'd' : 'M92,77.6v-13h2.7v4.9h5v-4.9h2.7v13h-2.7v-5.8h-5v5.8H92z'
    }
}, {
    'type' : 'path',
    'properties' : {
        'fill' : '#073867',
        'd' : 'M105.3,81.2c0,0.3,0,0.6,0.2,0.8c0.2,0.4,0.5,0.6,1,0.6c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.9c0-0.5-0.2-0.9-0.6-1c-0.2-0.1-0.6-0.1-1.1-0.1v-1.1c0.5,0,0.8-0.1,1-0.1c0.3-0.2,0.5-0.5,0.5-0.9c0-0.3-0.1-0.5-0.3-0.7s-0.4-0.3-0.7-0.3c-0.4,0-0.6,0.1-0.8,0.3c-0.2,0.2-0.3,0.5-0.2,0.9h-1.4c0-0.4,0.1-0.8,0.2-1.1c0.1-0.3,0.3-0.6,0.6-0.8c0.2-0.2,0.4-0.3,0.7-0.4c0.3-0.1,0.6-0.1,1-0.1c0.7,0,1.3,0.2,1.8,0.6c0.5,0.4,0.7,0.9,0.7,1.5c0,0.5-0.1,0.8-0.4,1.2c-0.2,0.2-0.4,0.3-0.5,0.4c0.1,0,0.3,0.1,0.6,0.4c0.4,0.4,0.6,0.9,0.6,1.5c0,0.7-0.2,1.2-0.7,1.7s-1.1,0.8-2,0.8c-1.1,0-1.9-0.4-2.3-1.1c-0.2-0.4-0.4-0.9-0.4-1.5H105.3z'
    }
}], [{
    'type' : 'polygon',
    'properties' : {
        'fill' : '#D8005B',
        'points' : '86.7,50.8 59.1,66.1 31.4,50.8 31.4,20.1 59.1,4.8 86.7,20.1 '
    }
}, {
    'type' : 'polygon',
    'properties' : {
        'opacity' : '0.5',
        'fill' : '#FFFFFF',
        'points' : '72.9,27.6 72.7,12.5 59,4.8 45.3,12.5 45.3,27.6 31.5,35.6 31.4,50.8 45.4,58.6 59.1,50.8 73,58.5 86.7,50.8 86.7,35.4 '
    }
}, {
    'type' : 'polygon',
    'properties' : {
        'opacity' : '0.5',
        'fill' : '#FFFFFF',
        'points' : '45.3,43.1 59.1,50.8 72.9,43.1 72.9,27.6 59.1,19.9 45.3,27.6 '
    }
}, {
    'type' : 'path',
    'properties' : {
        'fill' : '#073867',
        'd' : 'M86.8,64.6h2.8l-4.4,13h-2.6l-4.4-13h2.9l2.8,9.8L86.8,64.6z'
    }
}, {
    'type' : 'path',
    'properties' : {
        'fill' : '#073867',
        'd' : 'M100.7,76.4c-1,1-2.4,1.5-4.2,1.5s-3.3-0.5-4.2-1.5c-1.3-1.2-2-3-2-5.3c0-2.4,0.7-4.2,2-5.3c1-1,2.4-1.5,4.2-1.5s3.3,0.5,4.2,1.5c1.3,1.2,2,3,2,5.3C102.6,73.4,102,75.2,100.7,76.4z M99,74.5c0.6-0.8,0.9-1.9,0.9-3.4c0-1.5-0.3-2.6-0.9-3.4s-1.5-1.2-2.6-1.2s-1.9,0.4-2.6,1.2s-1,1.9-1,3.4s0.3,2.6,1,3.4s1.5,1.2,2.6,1.2S98.3,75.3,99,74.5z'
    }
}, {
    'type' : 'path',
    'properties' : {
        'fill' : '#073867',
        'd' : 'M105.6,66c1-1.1,2.4-1.6,4-1.6c2.2,0,3.7,0.7,4.7,2.1c0.6,0.8,0.8,1.6,0.9,2.4h-2.7c-0.2-0.6-0.4-1.1-0.7-1.4c-0.5-0.6-1.2-0.8-2.1-0.8c-1,0-1.7,0.4-2.3,1.2s-0.8,1.9-0.8,3.4s0.3,2.5,0.9,3.3c0.6,0.7,1.3,1.1,2.2,1.1c0.9,0,1.6-0.3,2.1-0.9c0.3-0.3,0.5-0.8,0.7-1.5h2.7c-0.2,1.4-0.8,2.6-1.8,3.4c-1,0.9-2.2,1.3-3.7,1.3c-1.8,0-3.3-0.6-4.3-1.8c-1.1-1.2-1.6-2.8-1.6-4.9C103.8,69,104.4,67.2,105.6,66z'
    }
}], [{
    'type' : 'polygon',
    'properties' : {
        'fill' : '#006FAF',
        'points' : '87.2,50.9 59.1,66.6 31.1,51.1 31.1,20 59.1,4.4 87.2,20 '
    }
}, {
    'type' : 'polygon',
    'properties' : {
        'fill' : '#004A7A',
        'points' : '59.1,66.6 31.1,51.1 31.1,20 59.1,4.4 '
    }
}, {
    'type' : 'polygon',
    'properties' : {
        'fill' : '#006FAF',
        'points' : '59,48.7 47.5,42.1 47.5,28.9 59,22.2 '
    }
}, {
    'type' : 'path',
    'properties' : {
        'fill' : '#073867',
        'd' : 'M80.5,66c1-1.1,2.4-1.6,4-1.6c2.2,0,3.7,0.7,4.7,2.1c0.6,0.8,0.8,1.6,0.9,2.4h-2.7c-0.2-0.6-0.4-1.1-0.7-1.4c-0.5-0.6-1.2-0.8-2.1-0.8c-1,0-1.7,0.4-2.3,1.2c-0.6,0.8-0.8,1.9-0.8,3.4s0.3,2.5,0.9,3.3c0.6,0.7,1.3,1.1,2.2,1.1c0.9,0,1.6-0.3,2.1-0.9c0.3-0.3,0.5-0.8,0.7-1.5H90c-0.2,1.4-0.8,2.6-1.8,3.4c-1,0.9-2.2,1.3-3.7,1.3c-1.8,0-3.3-0.6-4.3-1.8c-1.1-1.2-1.6-2.8-1.6-4.9C78.7,69,79.3,67.2,80.5,66z'
    }
}, {
    'type' : 'path',
    'properties' : {
        'fill' : '#073867',
        'd' : 'M92,77.6v-13h2.7v4.9h5v-4.9h2.7v13h-2.7v-5.8h-5v5.8H92z'
    }
}, {
    'type' : 'path',
    'properties' : {
        'fill' : '#073867',
        'd' : 'M109.2,82.1h-0.9v1.7h-1.5v-1.7h-3.1v-1.3l2.9-4.7h1.7v4.9h0.9V82.1z M106.9,80.9v-3.4l-1.9,3.4H106.9z'
    }
}, {
    'type' : 'polygon',
    'properties' : {
        'fill' : '#00AAFF',
        'points' : '70.5,42.1 59,48.7 59,22.2 70.5,28.9 '
    }
}], [{
    'type' : 'polygon',
    'properties' : {
        'fill' : '#31B5AD',
        'points' : '74,41.2 59.3,32.3 44.5,41.2 44.5,59 59.3,68 74,59 '
    }
}, {
    'type' : 'polygon',
    'properties' : {
        'fill' : '#008295',
        'points' : '88.7,32.3 74,41.2 59.3,32.3 59.3,14.4 74,5.5 88.7,14.4 '
    }
}, {
    'type' : 'polygon',
    'properties' : {
        'fill' : '#008295',
        'points' : '59.3,14.3 44.4,5.3 29.5,14.3 29.5,32.3 44.4,41.3 59.3,32.3 '
    }
}, {
    'type' : 'g',
    'properties' : {
        'opacity' : '0.8'
    }
}, {
    'type' : 'polygon',
    'properties' : {
        'fill' : '#FBFAFF',
        'points' : '74,23.2 59.3,14.3 44.5,23.2 44.5,41 59.3,49.9 74,41 '
    }
}, {
    'type' : 'path',
    'properties' : {
        'fill' : '#073867',
        'd' : 'M87.9,72c-0.8,0.6-1.8,0.9-3.2,0.9H82v4.7h-2.7v-13h5.6c1.3,0,2.3,0.3,3.1,1s1.1,1.7,1.1,3.1C89.1,70.3,88.7,71.4,87.9,72z M85.9,67.3c-0.3-0.3-0.8-0.4-1.4-0.4H82v3.8h2.4c0.6,0,1.1-0.2,1.4-0.5c0.3-0.3,0.5-0.8,0.5-1.5S86.2,67.6,85.9,67.3z'
    }
}, {
    'type' : 'path',
    'properties' : {
        'fill' : '#073867',
        'd' : 'M99.7,64.6h3.9v13H101v-8.8c0-0.3,0-0.6,0-1.1s0-0.8,0-1.1l-2.5,10.9H96l-2.4-10.9c0,0.2,0,0.6,0,1.1s0,0.8,0,1.1v8.8H91v-13H95l2.4,10.2L99.7,64.6z'
    }
}], [{
    'type' : 'polygon',
    'properties' : {
        'fill' : '#006FAF',
        'points' : '79.5,18.2 59.2,6.2 38.4,18 38.4,31.7 38.4,31.8 38.4,55.7 58.7,67.8 79.5,56 79.5,42.2 79.5,42.2 '
    }
}, {
    'type' : 'polygon',
    'properties' : {
        'fill' : '#029087',
        'points' : '46,51.5 46.1,36.6 59.1,29.2 71.8,36.7 71.8,51.6 58.9,59 '
    }
}, {
    'type' : 'polygon',
    'properties' : {
        'fill' : '#3AB2ED',
        'points' : '46,51.5 46.1,36.6 59.1,29.2 71.8,36.7 71.8,51.6 58.9,59 '
    }
}, {
    'type' : 'path',
    'properties' : {
        'fill' : '#073867',
        'd' : 'M89.2,76.4c-1,1-2.4,1.5-4.2,1.5s-3.3-0.5-4.2-1.5c-1.3-1.2-2-3-2-5.3c0-2.4,0.7-4.2,2-5.3c1-1,2.4-1.5,4.2-1.5s3.3,0.5,4.2,1.5c1.3,1.2,2,3,2,5.3C91.2,73.4,90.5,75.2,89.2,76.4z M87.5,74.5c0.6-0.8,0.9-1.9,0.9-3.4c0-1.5-0.3-2.6-0.9-3.4S86,66.5,85,66.5s-1.9,0.4-2.6,1.2s-1,1.9-1,3.4s0.3,2.6,1,3.4s1.5,1.2,2.6,1.2S86.9,75.3,87.5,74.5z'
    }
}, {
    'type' : 'path',
    'properties' : {
        'fill' : '#073867',
        'd' : 'M95.2,79.5c0,0.3,0,0.6,0.2,0.8c0.2,0.4,0.5,0.6,1,0.6c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.9c0-0.5-0.2-0.9-0.6-1c-0.2-0.1-0.6-0.1-1.1-0.1v-1.1c0.5,0,0.8-0.1,1-0.1c0.3-0.2,0.5-0.5,0.5-0.9c0-0.3-0.1-0.5-0.3-0.7c-0.2-0.2-0.4-0.3-0.7-0.3c-0.4,0-0.6,0.1-0.8,0.3c-0.2,0.2-0.3,0.5-0.2,0.9h-1.4c0-0.4,0.1-0.8,0.2-1.1c0.1-0.3,0.3-0.6,0.6-0.8c0.2-0.2,0.4-0.3,0.7-0.4s0.6-0.1,1-0.1c0.7,0,1.3,0.2,1.8,0.6s0.7,0.9,0.7,1.5c0,0.5-0.1,0.8-0.4,1.2c-0.2,0.2-0.4,0.3-0.5,0.4c0.1,0,0.3,0.1,0.6,0.4c0.4,0.4,0.6,0.9,0.6,1.5c0,0.7-0.2,1.2-0.7,1.7c-0.5,0.5-1.1,0.7-2,0.7c-1.1,0-1.9-0.4-2.3-1.1c-0.2-0.4-0.4-0.9-0.4-1.5H95.2z'
    }
}, {
    'type' : 'g',
    'properties' : {
        'opacity' : '0.8'
    }
}, {
    'type' : 'polygon',
    'properties' : {
        'fill' : '#FFFFFF',
        'points' : '46.1,36.6 46.1,21.6 59.2,14.2 71.8,21.8 71.8,36.7 59,44.1 '
    }
}]];

export default molecules;